import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  inject,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { UntilDestroy } from '@ngneat/until-destroy';
import { Store } from '@ngrx/store';
import { filter } from 'rxjs/operators';

import { TemplateDescriptionModalComponent } from '@main-application/shared/template-editor-dialog/components/template-editor-dialog/template-description-modal/template-description-modal.component';
import { TemplateEditorBase } from '@main-application/shared/template-editor-dialog/components/template-editor-dialog/template-editor-base/template-editor-base.component';
import { SnackbarService } from '@ui-components/components/customized-snackbar/snackbar.service';

@UntilDestroy()
@Component({
  selector: 'app-template-editor-description',
  templateUrl: './template-editor-description.component.html',
  styleUrls: ['./template-editor-description.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TemplateEditorDialogDescriptionComponent extends TemplateEditorBase implements AfterViewInit {
  protected store: Store<{}> = inject(Store);
  private dialog: MatDialog = inject(MatDialog);
  protected cdr: ChangeDetectorRef = inject(ChangeDetectorRef);

  editMode = false;
  initialized = false;
  isOverflowing = false;
  @Input() description!: string;
  @Input() templateHeader = '';

  @ViewChild('descriptionText', { read: ElementRef }) descriptionText: ElementRef<HTMLDivElement>;
  @Output() descriptionChanged = new EventEmitter<string>();
  @Input() isEditable: boolean;

  constructor(snackbarService: SnackbarService) {
    super(inject(Store), snackbarService);
  }

  ngAfterViewInit(): void {
    setTimeout(() => this.checkOverflow(), 0);
  }

  checkOverflow() {
    const el = document.querySelector('.inspection-description') as HTMLElement;
    if (el) {
      setTimeout(() => {
        this.isOverflowing = el.scrollHeight > 54;
        this.cdr.detectChanges();
      });
    }

    this.cdr.detectChanges();
  }

  checkEditRight(notify = true): boolean {
    return super.checkEditRight(this.isEditable, notify);
  }

  onTemplateDescriptionModal(): void {
    if (!this.checkEditRight()) return;

    this.dialog
      .open(TemplateDescriptionModalComponent, {
        autoFocus: false,
        width: '548px',
        panelClass: 'change-project-type-dialog',
        data: {
          description: this.description,
          editMode: !!this.description?.trim(),
          templateTitle: this.templateHeader,
        },
      })
      .afterClosed()
      .pipe(filter(data => !!data?.confirmed))
      .subscribe(data => {
        this.description = data.value || '';
        this.cdr.detectChanges();
        this.checkOverflow();
        this.descriptionChanged.emit(data.value || '');
      })
      .untilDestroyed(this);
  }
}
